(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["manly-product-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__manlyProductStoryReady) return;
    window.__manlyProductStoryReady = true;

    const selector = '[data-manly-product-story]';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const thresholds = [0.15, 0.29, 0.43, 0.57, 0.73];

    const stepForProgress = (progress) => {
      for (let index = 0; index < thresholds.length; index += 1) {
        if (progress < thresholds[index]) return index;
      }
      return thresholds.length;
    };

    const setup = (section) => {
      if (!section || section.__manlyProductStoryController) return;

      const track = section.querySelector('[data-mps-track]');
      const stage = section.querySelector('[data-mps-stage]');
      const entranceTarget = section.querySelector('.mps__japanese') || stage;
      const panels = Array.from(section.querySelectorAll('[data-mps-copy]'));
      let active = false;
      let frame = 0;
      let entranceObserver;
      let fabricTimer = 0;

      const setPanelAccessibility = (step) => {
        const effectiveStep = step === 0 && section.classList.contains('is-brand-split') ? 1 : step;
        panels.forEach((panel) => {
          const isActive = Number(panel.dataset.mpsCopy) === effectiveStep;
          panel.inert = !isActive;
          if (isActive) panel.removeAttribute('aria-hidden');
          else panel.setAttribute('aria-hidden', 'true');
        });
      };

      const restorePanelAccessibility = () => {
        panels.forEach((panel) => {
          panel.inert = false;
          panel.removeAttribute('aria-hidden');
        });
      };

      const enter = () => {
        section.classList.add('is-entered');
        if (entranceObserver) entranceObserver.disconnect();
      };

      const splitBrand = () => {
        if (section.classList.contains('is-brand-split')) return;
        section.classList.add('is-brand-split');
      };

      const buildCollage = () => {
        if (section.classList.contains('is-collage-built')) return;
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => section.classList.add('is-collage-built'));
        });
      };

      const playFabric = () => {
        if (!section.classList.contains('mps--detail-motion')) return;
        if (section.classList.contains('has-fabric-played')) return;
        section.classList.add('has-fabric-played', 'is-fabric-playing');
        fabricTimer = window.setTimeout(() => section.classList.remove('is-fabric-playing'), 2500);
      };

      const update = () => {
        frame = 0;
        if (!active || !track) return;
        const rect = track.getBoundingClientRect();
        const distance = Math.max(track.offsetHeight - window.innerHeight, 1);
        const progress = Math.min(Math.max(-rect.top / distance, 0), 1);
        const step = stepForProgress(progress);

        section.style.setProperty('--mps-progress', progress.toFixed(4));

        if (section.dataset.step !== String(step)) {
          section.dataset.step = String(step);
          if (step >= 1) splitBrand();
          setPanelAccessibility(step);
          if (step === 4) playFabric();
          if (step === 5) buildCollage();
        }

        if (!section.classList.contains('is-entered') && entranceTarget) {
          const entranceRect = entranceTarget.getBoundingClientRect();
          if (entranceRect.top < window.innerHeight * 0.92 && entranceRect.bottom > window.innerHeight * 0.08) enter();
        }
      };

      const requestUpdate = () => {
        if (!frame) frame = window.requestAnimationFrame(update);
      };

      const enable = () => {
        if (active || reducedMotion.matches || !track || !stage) return;
        active = true;
        section.classList.add('is-enhanced');
        setPanelAccessibility(Number(section.dataset.step || 0));
        window.addEventListener('scroll', requestUpdate, { passive: true });
        window.addEventListener('resize', requestUpdate, { passive: true });

        if ('IntersectionObserver' in window) {
          entranceObserver = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) enter();
          }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
          entranceObserver.observe(entranceTarget);
        }

        update();
      };

      const disable = () => {
        if (!active) {
          restorePanelAccessibility();
          return;
        }
        active = false;
        window.removeEventListener('scroll', requestUpdate);
        window.removeEventListener('resize', requestUpdate);
        if (frame) window.cancelAnimationFrame(frame);
        if (entranceObserver) entranceObserver.disconnect();
        if (fabricTimer) window.clearTimeout(fabricTimer);
        frame = 0;
        section.classList.remove('is-enhanced', 'is-fabric-playing');
        section.style.removeProperty('--mps-progress');
        restorePanelAccessibility();
      };

      const syncMotionPreference = () => {
        if (reducedMotion.matches) disable();
        else enable();
      };

      const destroy = () => {
        disable();
        if (reducedMotion.removeEventListener) reducedMotion.removeEventListener('change', syncMotionPreference);
        else reducedMotion.removeListener(syncMotionPreference);
        delete section.__manlyProductStoryController;
      };

      section.__manlyProductStoryController = { destroy };

      if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', syncMotionPreference);
      else reducedMotion.addListener(syncMotionPreference);

      syncMotionPreference();
    };

    const setupWithin = (root) => {
      if (root.matches && root.matches(selector)) setup(root);
      root.querySelectorAll(selector).forEach(setup);
    };

    const start = () => setupWithin(document);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();

    document.addEventListener('shopify:section:load', (event) => setupWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.matches && event.target.matches(selector)
        ? event.target
        : event.target.querySelector(selector);
      if (section && section.__manlyProductStoryController) section.__manlyProductStoryController.destroy();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
